/* Redneck Pepper — behaviour for rp-* sections.

   Two groups:
   - Buying (always on): add to cart without leaving the page, the flake
     burst, the sticky buy bar. Each falls back to plain Shopify behaviour.
   - Motion (only when snippets/rp-tokens.liquid put .rp-motion on <html>,
     meaning the setting is on, this is not the theme editor, and the visitor
     has not asked for reduced motion): scroll reveal, the story timeline,
     the rolling zeros. Without .rp-motion everything is already visible. */
(function () {
  var root = document.documentElement;
  var designMode = !!(window.Shopify && Shopify.designMode);
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function shopRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }
  function token(name, fallback) {
    var v = getComputedStyle(root).getPropertyValue(name).trim();
    return v || fallback;
  }

  /* ---------------------------------------------------------------- buying */

  function refreshCartCount() {
    return fetch(shopRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.rp-cart__n').forEach(function (el) {
          el.textContent = '· ' + cart.item_count;
        });
        document.querySelectorAll('#cart-icon-bubble .cart-count-bubble span[aria-hidden]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        var pill = document.querySelector('#cart-icon-bubble');
        if (pill && !reducedMotion) {
          pill.classList.remove('rp-bump');
          void pill.offsetWidth; /* restart the animation */
          pill.classList.add('rp-bump');
        }
      })
      .catch(function () {});
  }

  /* Every buy button on the page shows the same state, so the sticky bar and
     the main button never disagree. */
  function markAdded() {
    document.querySelectorAll('form[data-rp-atc] [type="submit"]').forEach(function (btn) {
      if (!btn.dataset.label) btn.dataset.label = btn.textContent.trim();
      if (btn.dataset.added) btn.textContent = btn.dataset.added;
      btn.classList.add('is-added');
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      clearTimeout(btn._rpReset);
      btn._rpReset = setTimeout(function () {
        btn.textContent = btn.dataset.label;
        btn.classList.remove('is-added');
      }, 6000);
    });
  }

  /* Pepper flakes. Spans, not divs: Dawn's base.css hides div:empty. */
  function burst(btn) {
    if (reducedMotion || !btn.animate) return;
    var r = btn.getBoundingClientRect();
    var x = r.left + r.width / 2;
    var y = r.top + r.height / 2;
    var colours = [
      token('--rp-red', '#C42B1E'), token('--rp-red', '#C42B1E'),
      token('--rp-brass', '#C08A35'), token('--rp-forest', '#2B3529'),
      token('--rp-bark', '#5A4632'), token('--rp-paper', '#E7E1D1')
    ];
    for (var i = 0; i < 30; i++) {
      var f = document.createElement('span');
      var w = 3 + Math.random() * 6;
      var h = 2 + Math.random() * 3.5;
      f.setAttribute('aria-hidden', 'true');
      f.style.cssText = 'display:block;position:fixed;z-index:2147483000;pointer-events:none;' +
        'left:' + (x - w / 2) + 'px;top:' + (y - h / 2) + 'px;width:' + w + 'px;height:' + h + 'px;' +
        'border-radius:1px;background:' + colours[i % colours.length] + ';';
      document.body.appendChild(f);
      var a = (-160 + Math.random() * 140) * Math.PI / 180; /* mostly upward */
      var v = 60 + Math.random() * 120;
      var dx = Math.cos(a) * v;
      var dy = Math.sin(a) * v;
      var spin = (Math.random() - 0.5) * 720;
      f.animate([
        { transform: 'translate(0,0) rotate(0deg)', opacity: 1 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) rotate(' + spin / 2 + 'deg)', opacity: 1, offset: 0.5 },
        { transform: 'translate(' + dx * 1.25 + 'px,' + (dy + 140) + 'px) rotate(' + spin + 'deg)', opacity: 0 }
      ], {
        duration: 850 + Math.random() * 550,
        easing: 'cubic-bezier(.2,.7,.35,1)'
      }).onfinish = (function (el) { return function () { el.remove(); }; })(f);
    }
  }

  function buying() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[data-rp-atc]')) return;
      var btn = form.querySelector('[type="submit"]');
      if (!btn || btn.dataset.mode === 'cart' || !window.fetch || !window.FormData) return;

      e.preventDefault();
      if (btn.classList.contains('is-added')) {
        window.location.href = shopRoot() + 'cart';
        return;
      }
      if (btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;

      fetch(shopRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          if (btn.dataset.burst === 'true') burst(btn);
          markAdded();
          refreshCartCount();
        })
        .catch(function () {
          /* Let Shopify handle it the normal way, including its error page. */
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          form.submit();
        });
    });
  }

  /* The bar shows once the section's own button has scrolled up out of
     view, and hides again at the footer so it never covers it. */
  function stickyBar() {
    var bar = document.querySelector('[data-rp-sticky]');
    var cta = document.querySelector('.rp-prod__cta');
    if (!bar || !cta || designMode || !('IntersectionObserver' in window)) return;
    var foot = document.querySelector('.footer, footer');
    var past = false;
    var atFoot = false;

    function set() {
      var up = past && !atFoot;
      bar.classList.toggle('is-up', up);
      if (up) { bar.removeAttribute('inert'); } else { bar.setAttribute('inert', ''); }
    }
    bar.setAttribute('inert', '');
    bar.hidden = false;
    new IntersectionObserver(function (es) {
      var e = es[0];
      past = !e.isIntersecting && e.boundingClientRect.top < 0;
      set();
    }).observe(cta);
    if (foot) {
      new IntersectionObserver(function (es) {
        atFoot = es[0].isIntersecting;
        set();
      }).observe(foot);
    }
  }

  /* Product gallery: thumbnails swap the main photo. */
  function galleries() {
    document.querySelectorAll('[data-rp-gal]').forEach(function (g) {
      var imgs = g.querySelectorAll('.rp-gal__img');
      var thumbs = g.querySelectorAll('[data-rp-gal-t]');
      g.classList.add('is-js');
      function show(i) {
        imgs.forEach(function (im, k) { im.classList.toggle('is-on', k === i); });
        thumbs.forEach(function (t, k) {
          t.classList.toggle('is-on', k === i);
          if (k === i) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); }
        });
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { show(+t.dataset.rpGalT); });
      });
      show(0);
    });
  }

  /* TikTok cards: fetch each cover from TikTok's oEmbed (it allows any site),
     and swap in the player only when clicked. In the theme editor TikTok
     refuses the player, so the card's normal link opens TikTok instead. */
  function tiktoks() {
    document.querySelectorAll('[data-rp-tt]').forEach(function (a) {
      fetch('https://www.tiktok.com/oembed?url=' + encodeURIComponent(a.href))
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || !d.thumbnail_url) return;
          var img = document.createElement('img');
          img.className = 'rp-vid__cover';
          img.alt = '';
          img.loading = 'lazy';
          img.src = d.thumbnail_url;
          a.insertBefore(img, a.firstChild);
        })
        .catch(function () {});
      if (designMode) return;
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var f = document.createElement('iframe');
        f.src = 'https://www.tiktok.com/player/v1/' + a.dataset.rpTt +
          '?autoplay=1&music_info=0&description=0&rel=0';
        f.title = a.getAttribute('aria-label') || 'TikTok video';
        f.allow = 'autoplay; fullscreen; encrypted-media; picture-in-picture';
        f.allowFullscreen = true;
        a.replaceWith(f);
      });
    });
  }

  /* Story page year counter: shows the year of the last marked block that has
     passed the middle of the screen, only while the story is on screen. */
  function sagaYears() {
    var saga = document.querySelector('[data-rp-saga]');
    if (!saga) return;
    var marks = saga.querySelectorAll('[data-rp-year]');
    var wrap = saga.querySelector('.rp-saga__year');
    var badge = wrap && wrap.querySelector('span');
    if (!marks.length || !badge) return;
    var ticking = false;
    function update() {
      ticking = false;
      var mid = window.innerHeight * 0.5;
      var cur = null;
      marks.forEach(function (m) { if (m.getBoundingClientRect().top < mid) cur = m; });
      var r = saga.getBoundingClientRect();
      var inView = r.top < window.innerHeight * 0.4 && r.bottom > window.innerHeight * 0.6;
      wrap.classList.toggle('is-on', !!cur && inView);
      if (!cur) return;
      wrap.classList.toggle('is-dark', !!cur.closest('.rp-act--quiet'));
      if (badge.textContent !== cur.dataset.rpYear) {
        badge.textContent = cur.dataset.rpYear;
        if (!reducedMotion) { wrap.classList.remove('tick'); void wrap.offsetWidth; wrap.classList.add('tick'); }
      }
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* ---------------------------------------------------------------- motion */

  /* Keep in step with the matching list in assets/rp.css (search "reveal"). */
  var REVEAL = [
    '.rp-hero .rp-eyebrow', '.rp-hero .rp-h1', '.rp-hero .rp-sub', '.rp-hero .rp-cta', '.rp-hero__media',
    '.rp-zeros__i',
    '.rp-prod__media', '.rp-prod__body > *',
    '.rp-quote blockquote', '.rp-quote cite',
    '.rp-story__ph', '.rp-story .rp-label', '.rp-stop',
    '.rp-uses__hd', '.rp-grid__i',
    '.rp-reviews .rp-eyebrow', '.rp-reviews .rp-h2', '.rp-rev',
    '.rp-gear .rp-h2', '.rp-gear p', '.rp-list a', '.rp-gear__ph', '.rp-gear__hd .rp-link', '.rp-card',
    '.rp-close .rp-in > *',
    '.rp-shows__hd', '.rp-show', '.rp-recipe__intro', '.rp-recipe__form',
    '.rp-videos__hd', '.rp-vid',
    '.rp-saga__intro', '.rp-act__in', '.rp-sg-text', '.rp-beat', '.rp-punch', '.rp-scene__after',
    '.rp-scrap__text', '.rp-scrap__p', '.rp-scrap__tag', '.rp-date', '.rp-stmt__t', '.rp-fans__text',
    '.rp-fans__p', '.rp-finale'
  ].join(',');

  function reveal() {
    var els = document.querySelectorAll(REVEAL);
    var seen = new Map();
    els.forEach(function (el) {
      var n = seen.get(el.parentNode) || 0;
      seen.set(el.parentNode, n + 1);
      el.style.setProperty('--rp-i', Math.min(n, 10));
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Each digit becomes a reel of digits that spins down and lands on the
     real one. The real text stays in aria-label for screen readers. */
  function rollers() {
    document.querySelectorAll('.rp-zeros[data-rp-roll] .rp-zeros__n').forEach(function (n) {
      var txt = n.textContent.trim();
      if (!/\d/.test(txt) || n.querySelector('.rp-reel')) return;
      n.setAttribute('aria-label', txt);
      n.textContent = '';
      txt.split('').forEach(function (ch, k) {
        if (!/\d/.test(ch)) {
          var s = document.createElement('span');
          s.setAttribute('aria-hidden', 'true');
          s.textContent = ch;
          n.appendChild(s);
          return;
        }
        var d = +ch;
        var steps = 14 + k * 3;
        var reel = document.createElement('span');
        reel.className = 'rp-reel';
        reel.setAttribute('aria-hidden', 'true');
        var strip = document.createElement('span');
        strip.className = 'rp-reel__s';
        strip.style.setProperty('--rp-steps', steps);
        for (var j = steps; j >= 0; j--) {
          var digit = document.createElement('span');
          digit.textContent = (d + j) % 10;
          strip.appendChild(digit);
        }
        reel.appendChild(strip);
        n.appendChild(reel);
      });
    });
  }

  /* The story line fills as the reader moves down it, and each dot lights
     as the fill reaches it. */
  function timelines() {
    var tracks = Array.prototype.slice.call(document.querySelectorAll('.rp-track'));
    if (!tracks.length) return;
    var ticking = false;

    function update() {
      ticking = false;
      var line = window.innerHeight * 0.62;
      tracks.forEach(function (t) {
        var r = t.getBoundingClientRect();
        var p = r.height ? (line - r.top) / r.height : 0;
        t.style.setProperty('--rp-p', Math.max(0, Math.min(1, p)).toFixed(3));
        t.querySelectorAll('.rp-stop').forEach(function (s) {
          s.classList.toggle('is-on', s.getBoundingClientRect().top + 8 < line);
        });
      });
    }
    function queue() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    update();
  }

  /* Turn on smooth scrolling only after the browser has done its own jump to
     any #anchor in the address, so arriving at an anchor is instant. */
  function smoothLater() {
    function on() { setTimeout(function () { root.classList.add('rp-smooth'); }, 120); }
    if (document.readyState === 'complete') { on(); } else { window.addEventListener('load', on); }
  }

  function start() {
    smoothLater();
    buying();
    stickyBar();
    galleries();
    tiktoks();
    sagaYears();
    if (!root.classList.contains('rp-motion')) return;
    window.rpMotionReady = true;
    rollers();
    reveal();
    timelines();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
